export default {
  SET_VALID_MODE: ({ commit }, payload) =>
    new Promise(() => {
      commit("SET_VALID_MODE", payload);
    }),
};
